// Centralised test IDs for STC Marine Services landing site.
// kebab-case, role-based names.

export const NAV = {
  root: 'nav-root',
  logoLink: 'nav-logo-link',
  homeLink: 'nav-home-link',
  servicesLink: 'nav-services-link',
  aboutLink: 'nav-about-link',
  whyLink: 'nav-why-link',
  contactLink: 'nav-contact-link',
  mobileToggle: 'nav-mobile-toggle',
  mobileMenu: 'nav-mobile-menu',
  ctaContact: 'nav-cta-contact',
  linkedin: 'nav-linkedin-link',
};

export const LANG = {
  trigger: 'lang-switcher-trigger',
  itemEn: 'lang-switcher-item-en',
  itemEs: 'lang-switcher-item-es',
};

export const HERO = {
  root: 'hero-section',
  ctaPrimary: 'hero-cta-primary',
  ctaSecondary: 'hero-cta-secondary',
};

export const ABOUT = {
  root: 'about-section',
};

export const SERVICES = {
  gridRoot: 'services-grid',
  card: (slug) => `service-card-${slug}`,
  detailRoot: 'services-detail-root',
  detailItem: (slug) => `service-detail-${slug}`,
  ctaSchedule: 'services-cta-schedule',
};

export const WHY = {
  root: 'why-choose-us-section',
};

export const FAQ = {
  root: 'faq-section',
  item: (idx) => `faq-item-${idx}`,
  trigger: (idx) => `faq-trigger-${idx}`,
};

export const CONTACT = {
  section: 'contact-section',
  formRoot: 'contact-form',
  inputName: 'contact-input-name',
  inputEmail: 'contact-input-email',
  inputCompany: 'contact-input-company',
  selectService: 'contact-select-service',
  selectServiceItem: (slug) => `contact-service-${slug}`,
  inputMessage: 'contact-input-message',
  submit: 'contact-submit-button',
  successAlert: 'contact-success-alert',
  errorAlert: 'contact-error-alert',
  emailLink: 'contact-email-link',
  phoneLink: 'contact-phone-link',
};

export const FOOTER = {
  root: 'footer-root',
  emailLink: 'footer-email-link',
  phoneLink: 'footer-phone-link',
  linkedin: 'footer-linkedin-link',
};

// Legacy export for any auto-generated imports
export const HOME = {
  emergentLink: 'home-emergent-link',
};
